import { AccessRightDomain } from '../types/access-right.interface';
import { EntityDefinition } from '../types/entity-definition.interface';

export const accessRightAssetDefinition: EntityDefinition<AccessRightDomain> = {
  entityType: 'AccessRightDomain',
  i18nBase: 'entities.accessAsset',
  list: {
    columns: [
      {
        field: 'name',
        headerKey: 'entities.accessAsset.columns.user',
        sortable: true,
        filterable: true,
        class: 'min-w-[200px]',
        contentClass: 'line-clamp-1',
        showTooltip: true,
      },
      {
        field: 'company',
        headerKey: 'entities.accessAsset.columns.company',
        sortable: true,
        filterable: true,
        class: 'min-w-[250px]',
        contentClass: 'line-clamp-1',
        showTooltip: true,
      },
      {
        field: 'roleName',
        headerKey: 'entities.accessAsset.columns.role',
        sortable: true,
        filterable: true,
        class: 'min-w-[250px]',
        contentClass: 'line-clamp-1',
        showTooltip: true,
      },
    ],
  },
  fields: [],
  validationRules: [],
  actionButtons: {
    parent: {
      edit: true,
    },
  },
  formOptions: {
    showDeleteButton: true,
  },
  messages: {
    dialogTitles: {
      create: () => 'entities.accessAsset.messages.createTitle',
      edit: () => 'entities.accessAsset.messages.editTitleWithName',
      delete: () => 'entities.accessAsset.messages.deleteTitleWithName',
    },
    buttons: {
      add: () => ``,
      create: () => ``,
      edit: () => ``,
      delete: () => ``,
    },
    confirmDelete: () => 'entities.accessAsset.messages.deleteConfirm',
  },
  deleteName: entity => entity.name,
  enableFiltering: true,
};
